/**
 * The fills the sidebar paints behind a nav row.
 *
 * Kept in one module rather than inline so the expanded sidebar and the
 * collapsed rail cannot drift apart -- they render from different branches of
 * `NavItem` but have to look like the same control.
 */

/** The active row: a flat primary fill, with the text/icon colour to match. */
export const activeNavSurface = (theme) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
});

/** The quiet hover fill for a row that is *not* active. */
export const hoverNavSurface = (theme) => ({
  background: theme.palette.custom.primarySubtle,
});
